export enum QuestState {
	/** Квест недоступен из-за зависимостей */
	LOCKED = 'locked',
	/** Квест доступен для взятия */
	AVAILABLE = 'available',
	/** Взяли квест */
	ACTIVE = 'active',
	/** Квест готов к сдаче */
	READY = 'ready',
	/** Квест сдан и награда получена */
	FINISHED = 'finished',
}

export enum HudTaskType {
	QUEST = 'quest',
	DAILY = 'daily',
}

export interface ICharacterQuestData {
	progress: number;
	isPinned: boolean;
	isFinished: boolean;
}

export interface IQuestProgress {
	progress: number;
	state: QuestState;
}

export interface IHudTaskProgress {
	text: string;
	type: HudTaskType.QUEST | HudTaskType.DAILY;
	targetCount: number;
	currentCount: number;
}

export enum QuestId {
	// Квесты Тёти Розы
	TALK_WITH_AUNT_ROSE_INITIAL = 'aunt_rose_quest_initial',
	OPEN_PLAYER_VEHICLES_MENU = 'aunt_rose_quest_0',
	TALK_WITH_AUNT_ROSE_0 = 'aunt_rose_quest_0_1',
	GET_DOCUMENTS_AT_POLICE_STATION = 'aunt_rose_quest_1_0',
	RETURN_TO_AUNT_ROSE_FOR_REWARD_1 = 'aunt_rose_quest_1_1',
	TALK_WITH_AUNT_ROSE_1 = 'aunt_rose_quest_1_2',
	GET_TO_CONSTRUCTION_SITE = 'aunt_rose_quest_2_0',
	JOB_BUILDER = 'aunt_rose_quest_2_1',
	TALK_TO_UNCLE_AND_FINISH_SHIFT = 'aunt_rose_quest_2_2',
	ACTIVATE_BANK_ACCOUNT = 'aunt_rose_quest_2_3',
	TALK_TO_UNCLE_NEAR_BANK = 'aunt_rose_quest_2_4',
	TALK_WITH_AUNT_ROSE_2 = 'aunt_rose_quest_2_5',
	GET_TO_DELIVERY_JOB = 'aunt_rose_quest_3_0',
	JOB_DELIVERY = 'aunt_rose_quest_3_1',
	TALK_TO_UNCLE_AND_FINISH_DELIVERY_SHIFT = 'aunt_rose_quest_3_2',
	RETURN_TO_AUNT_ROSE_FOR_REWARD_3 = 'aunt_rose_quest_3_3',
	TALK_WITH_AUNT_ROSE_3 = 'aunt_rose_quest_3_4',
	VISIT_CLOTHES_SHOP = 'aunt_rose_quest_4_0',
	RETURN_TO_AUNT_ROSE_FOR_REWARD_4 = 'aunt_rose_quest_4_1',
	TALK_WITH_AUNT_ROSE_4 = 'aunt_rose_quest_4_2',
	// От этих отказались. Телефон доступен игроку сразу
	// DIALOGUE_GET_PHONE = 'aunt_rose_quest_5_0',
	// DIALOGUE_AFTER_GETTING_PHONE = 'aunt_rose_quest_5_1',
	GET_TO_FARM_JOB = 'aunt_rose_quest_6_0',
	JOB_FARMER = 'aunt_rose_quest_6_1',
	FINISH_FARM_SHIFT = 'aunt_rose_quest_6_2',
	RETURN_TO_AUNT_ROSE_FOR_REWARD_6 = 'aunt_rose_quest_6_3',
	TALK_WITH_AUNT_ROSE_6 = 'aunt_rose_quest_6_4',
	VISIT_BARBER_SHOP = 'aunt_rose_quest_7_0',
	RETURN_TO_AUNT_ROSE_FOR_REWARD_7 = 'aunt_rose_quest_7_1',
	TALK_WITH_AUNT_ROSE_7 = 'aunt_rose_quest_7_2',
	DRINK_ALCOHOL_IN_MOJITO_BAR = 'aunt_rose_quest_8',
	VISIT_UNCLE_SAM_FINAL_QUEST = 'aunt_rose_quest_9',

	// Квесты Дяди Сема (и Семёныча)
	GET_DRIVING_LICENSE = 'uncle_sam_quest_10_0',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_10 = 'uncle_sam_quest_10_1',
	TALK_WITH_UNCLE_SAM_10 = 'uncle_sam_quest_10_2',
	GET_TO_TAXI_JOB = 'uncle_sam_quest_11_0',
	JOB_TAXI = 'uncle_sam_quest_11_1',
	FINISH_TAXI_SHIFT = 'uncle_sam_quest_11_2',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_11 = 'uncle_sam_quest_11_3',
	TALK_WITH_UNCLE_SAM_11 = 'uncle_sam_quest_11_4',
	VISIT_TATTOO_SHOP = 'uncle_sam_quest_12_0',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_12 = 'uncle_sam_quest_12_1',
	TALK_WITH_UNCLE_SAM_12 = 'uncle_sam_quest_12_2',
	DISPOSE_VEHICLE = 'uncle_sam_quest_13',
	TALK_WITH_UNCLE_SAM_13 = 'uncle_sam_quest_13_1',
	BUY_VEHICLE = 'uncle_sam_quest_14_0',
	REGISTER_VEHICLE = 'uncle_sam_quest_14_1',
	REFUEL_VEHICLE = 'uncle_sam_quest_14_2',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_14 = 'uncle_sam_quest_14_3',
	TALK_WITH_UNCLE_SAM_14 = 'uncle_sam_quest_14_4',
	VISIT_TECH_TUNING = 'uncle_sam_quest_15_0',
	VISIT_TUNING_STUDIO = 'uncle_sam_quest_15_1',
	VISIT_VEHICLE_SERVICE = 'uncle_sam_quest_15_2',
	VISIT_CAR_WASH = 'uncle_sam_quest_15_3',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_15 = 'uncle_sam_quest_15_4',
	TALK_WITH_UNCLE_SAM_15 = 'uncle_sam_quest_15_5',
	VISIT_FISHERMAN_SEMENYCH = 'uncle_sam_quest_16',
	// 17 - BUY_FISHING_LICENSE - пропущен (TODO)
	BUY_FISHING_ROD_AND_BAIT = 'uncle_sam_quest_18_0',
	RETURN_TO_FISHERMAN_FOR_REWARD_18 = 'uncle_sam_quest_18_1',
	TALK_WITH_FISHERMAN_18 = 'uncle_sam_quest_18_2',
	HOBBY_FISHING = 'uncle_sam_quest_19_0',
	SELL_FISH_TO_BUYER = 'uncle_sam_quest_19_1',
	RETURN_TO_FISHERMAN_FOR_REWARD_19 = 'uncle_sam_quest_19_2',
	TALK_WITH_UNCLE_SAM_19 = 'uncle_sam_quest_19_3',
	GET_BUS_LICENSE = 'uncle_sam_quest_20_0',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_20_1 = 'uncle_sam_quest_20_1',
	TALK_WITH_UNCLE_SAM_20_1 = 'uncle_sam_quest_20_1_1',
	GET_TO_BUS_JOB = 'uncle_sam_quest_20_2',
	JOB_BUS = 'uncle_sam_quest_20_3',
	FINISH_BUS_SHIFT = 'uncle_sam_quest_20_4',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_20_5 = 'uncle_sam_quest_20_5',
	TALK_WITH_UNCLE_SAM_20 = 'uncle_sam_quest_20_6',
	GET_TO_COURIER_JOB = 'uncle_sam_quest_21_0',
	JOB_COURIER = 'uncle_sam_quest_21_1',
	FINISH_COURIER_SHIFT = 'uncle_sam_quest_21_2',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_21 = 'uncle_sam_quest_21_3',
	TALK_WITH_UNCLE_SAM_21 = 'uncle_sam_quest_21_4',
	GET_TO_ELECTRICIAN_JOB = 'uncle_sam_quest_22_0',
	JOB_ELECTRICIAN = 'uncle_sam_quest_22_1',
	FINISH_ELECTRICIAN_SHIFT = 'uncle_sam_quest_22_2',
	RETURN_TO_UNCLE_SAM_FOR_REWARD_22 = 'uncle_sam_quest_22_3',
	TALK_WITH_UNCLE_SAM_23 = 'uncle_sam_quest_23',
}
